var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"toolbarwrapper",attrs:{"tabindex":"0"},on:{"keydown":_vm.onKeyDown,"focus":_vm.onFocus,"blur":_vm.onBlur,"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }